import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";

import { ScreenLayout } from "@/app/components/layouts";
import { ErrorState } from "@/app/components/legacy-components";
import { usePatientProductsByCategory } from "@/features/products/hooks";
import { LogoLoader } from "@/shared/components";
import { Category } from "@/shared/domains";
import { Form } from "@/shared/ui";
import {
  ChangeSubscriptionContent,
  ChangeSubscriptionFooter,
  ChangeSubscriptionHeader,
} from "./sections";
import { subscriptionSchema } from "./shared";

export const ChangeSubscription = () => {
  const form = useForm({
    resolver: zodResolver(subscriptionSchema),
    defaultValues: {
      hasConsent: false,
    },
  });

  const location = useLocation();
  const parsedCategory = Category.pick({
    id: true,
    slug: true,
    name: true,
  }).safeParse(location.state);

  const {
    data: products,
    isSuccess,
    isLoading,
    isError,
  } = usePatientProductsByCategory(parsedCategory.data?.id);

  if (parsedCategory.error || isError) {
    return <ErrorState className="-translate-y-10 border-none" />;
  }

  return (
    <ScreenLayout className="lg:gap-1">
      <LogoLoader show={isLoading} withOverlay />

      <ChangeSubscriptionHeader />

      <Form.Provider {...form}>
        {isSuccess && (
          <div className="flex grow flex-col gap-6 lg:gap-0">
            <ChangeSubscriptionContent products={products} />

            <ChangeSubscriptionFooter />
          </div>
        )}
      </Form.Provider>
    </ScreenLayout>
  );
};
